import React, { useEffect, useState, memo } from 'react';
import { NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { habilitarHoras, obtenerEstadoHorasHabilitadas, fetchUsuarios } from '../../actions/index.js';
import './Navbar.css';

function Navbar({ user, handleLogout, onCrearCliente, onEditarCliente, onConsultarCliente }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isClienteAccordionOpen, setIsClienteAccordionOpen] = useState(false);
  const [isReportesAccordionOpen, setIsReportesAccordionOpen] = useState(false);
  const [isHorasSelectorOpen, setIsHorasSelectorOpen] = useState(false);
  const [busquedaUsuario, setBusquedaUsuario] = useState('');
  const [usuariosSeleccionados, setUsuariosSeleccionados] = useState([]);
  const dispatch = useDispatch();
  const horasHabilitadas = useSelector(state => state.horasHabilitadas);
  const usuariosHabilitados = useSelector(state => state.usuariosHorasHabilitadas || []);
  const usuarios = useSelector(state => state.usuarios || []);

  useEffect(() => {
    if (user && user.perfil === 'Administrador del sistema') {
      dispatch(fetchUsuarios());
      dispatch(obtenerEstadoHorasHabilitadas());
    }
  }, [dispatch, user]);

  useEffect(() => {
    if (Array.isArray(usuariosHabilitados)) {
      setUsuariosSeleccionados(usuariosHabilitados);
    }
  }, [usuariosHabilitados]);

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleClienteAccordionToggle = () => {
    setIsClienteAccordionOpen(!isClienteAccordionOpen);
  };

  const handleReportesAccordionToggle = () => {
    setIsReportesAccordionOpen(!isReportesAccordionOpen);
  };



  const handleHabilitarHoras = () => {
    // Siempre abrir el selector para gestionar usuarios
    setIsHorasSelectorOpen(true);
  };

  const handleToggleUsuario = (usuarioId) => {
    setUsuariosSeleccionados(prev => {
      if (prev.includes(usuarioId)) {
        return prev.filter(id => id !== usuarioId);
      }
      return [...prev, usuarioId];
    });
  };

  const handleConfirmarHabilitar = () => {
    // Permitir array vacío para deshabilitar todos los usuarios
    if (usuariosSeleccionados.length === 0) {
      const confirmar = window.confirm('No hay usuarios seleccionados. Esto deshabilitará las horas para todos (excepto últimos 3 meses). ¿Continuar?');
      if (!confirmar) return;
    }
    dispatch(habilitarHoras(usuariosSeleccionados));
    setIsHorasSelectorOpen(false);
    setBusquedaUsuario('');
  };

  const handleCancelarSelector = () => {
    setIsHorasSelectorOpen(false);
    setBusquedaUsuario('');
    setUsuariosSeleccionados(usuariosHabilitados);
  };

  const usuariosFiltrados = usuarios.filter(usuario => {
    const busqueda = busquedaUsuario.toLowerCase().trim();
    if (!busqueda) return true;
    const nombreCompleto = `${usuario.nombre || ''} ${usuario.apellidos || ''} ${usuario.email || ''}`.toLowerCase();
    return nombreCompleto.includes(busqueda);
  });

  const getNombreUsuario = (usuario) => {
    const nombre = `${usuario.nombre || ''} ${usuario.apellidos || ''}`.trim();
    return nombre || usuario.email || `Usuario ${usuario.id}`;
  };

  return (
    <div className="navbar">
      <div className="left-section">
        <img src={require('../../images/isologo-expansion-blanco.svg').default} alt="Logo" className="isologo" />
        <div className="user-info">
          {user && (user.nombre || user.apellidos) && (
            <div className="user-fullname">
              {user.nombre} {user.apellidos}
            </div>
          )}
        </div>
      </div>
      <div className="nav-links-container">
        <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
          <li>
            <NavLink to="/home" exact activeClassName="active">
              Inicio
            </NavLink>
          </li>
          <li className="reportes-accordion">
            <button
              className="nav-button accordion-toggle"
              onClick={handleReportesAccordionToggle}
            >
              Reportes
              <span className={`accordion-arrow ${isReportesAccordionOpen ? 'open' : ''}`}>
                ▾
              </span>
            </button>
            <div className={`accordion-content ${isReportesAccordionOpen ? 'open' : ''}`}>
              <NavLink
                to="/reportes/usuario"
                className="nav-button accordion-item"
                activeClassName="active"
              >
                Reporte Usuario
              </NavLink>
              <NavLink
                to="/reportes/clientes"
                className="nav-button accordion-item"
                activeClassName="active"
              >
                Reporte Cliente
              </NavLink>
              <NavLink
                to="/reportes/area"
                className="nav-button accordion-item"
                activeClassName="active"
              >
                Reporte Área
              </NavLink>
            </div>
          </li>
          {user && user.perfil === 'Administrador del sistema' && (
            <>
              <li className="horas-selector">
                <button className="nav-button" onClick={handleHabilitarHoras}>
                  Gestionar horas
                  {usuariosHabilitados.length > 0 && (
                    <span className="nav-badge">{usuariosHabilitados.length}</span>
                  )}
                </button>
                {isHorasSelectorOpen && (
                  <div className="horas-selector-modal">
                    <div className="horas-selector-header">
                      <h3>Gestionar habilitación de horas</h3>
                      <button className="horas-selector-close" onClick={handleCancelarSelector}>×</button>
                    </div>
                    <div className="horas-selector-busqueda">
                      <input
                        type="text"
                        placeholder="Buscar usuario por nombre o email..."
                        value={busquedaUsuario}
                        onChange={(e) => setBusquedaUsuario(e.target.value)}
                      />
                    </div>
                    <div className="horas-selector-chips">
                      {usuariosSeleccionados.length === 0 ? (
                        <span className="horas-selector-empty">Ningún usuario seleccionado</span>
                      ) : (
                        usuariosSeleccionados.map(usuarioId => {
                          const usuario = usuarios.find(u => u.id === usuarioId);
                          if (!usuario) return null;
                          return (
                            <span key={usuarioId} className="horas-selector-chip">
                              {getNombreUsuario(usuario)}
                              <button onClick={() => handleToggleUsuario(usuarioId)}>×</button>
                            </span>
                          );
                        })
                      )}
                    </div>
                    <div className="horas-selector-list">
                      {usuariosFiltrados.map(usuario => (
                        <label key={usuario.id} className="horas-selector-item">
                          <input
                            type="checkbox"
                            checked={usuariosSeleccionados.includes(usuario.id)}
                            onChange={() => handleToggleUsuario(usuario.id)}
                          />
                          <span>{getNombreUsuario(usuario)}</span>
                        </label>
                      ))}
                    </div>
                    <div className="horas-selector-actions">
                      <button className="horas-selector-btn-cancel" onClick={handleCancelarSelector}>
                        Cancelar
                      </button>
                      <button className="horas-selector-btn-apply" onClick={handleConfirmarHabilitar}>
                        {usuariosSeleccionados.length === 0 ? 'Deshabilitar todos' : `Aplicar (${usuariosSeleccionados.length} usuarios)`}
                      </button>
                    </div>
                  </div>
                )}
              </li>
              <li className="cliente-accordion">
                <button 
                  className="nav-button accordion-toggle" 
                  onClick={handleClienteAccordionToggle}
                >
                  Administración
                  <span className={`accordion-arrow ${isClienteAccordionOpen ? 'open' : ''}`}>
                    ▾
                  </span>
                </button>
                <div className={`accordion-content ${isClienteAccordionOpen ? 'open' : ''}`}>
                  <NavLink
                    to="/usuarios"
                    className="nav-button accordion-item"
                    activeClassName="active"
                  >
                    Gestión de Usuarios
                  </NavLink>
                  <button className="nav-button nav-button-crear accordion-item" onClick={onCrearCliente}>
                    Crear Cliente
                  </button>
                  <button className="nav-button nav-button-editar accordion-item" onClick={onEditarCliente}>
                    Editar Cliente
                  </button>
                  <button className="nav-button nav-button-consultar accordion-item" onClick={onConsultarCliente}>
                    Consultar Cliente
                  </button>
                </div>
              </li>
            </>
          )}
          <li>
            <NavLink to="/mishoras" activeClassName="active">
              Mis Horas
            </NavLink>
          </li>
          <li>
            <NavLink to="/perfil" activeClassName="active">
              Mi Perfil
            </NavLink>
          </li>
          <li>
            <button
              className="nav-button logout-button"
              onClick={handleLogout}
            >
              Cerrar sesión
            </button>
          </li>
        </ul>
        <div className="menu-toggle" onClick={handleMenuToggle}>
        <div className={`menu-icon ${isMenuOpen ? 'active' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
 
      </div>
    </div>
  );
}

export default memo(Navbar);